"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoutModalContext = void 0;
const react_1 = require("react");
exports.LogoutModalContext = (0, react_1.createContext)(undefined);
